import { Injectable } from "@angular/core"

export interface UserSettings {
  email: string
  roles: string[]
  uid: string
  company: string
  project?: string
}

@Injectable({
  providedIn: "root",
})
export class SessionService {
  private settingsName = "Settings"
  public testRampAuthName = "testRampAuth"

  public setSettings(data: UserSettings): void {
    this.setItem<UserSettings>(this.settingsName, data)
  }

  public setItem<T>(storageName: string, data: T): void {
    localStorage.setItem(storageName, JSON.stringify(data))
  }

  public getItem<T>(storageName: string): any {
    return JSON.parse(localStorage.getItem(storageName)) as T
  }

  public getUserSettings(): UserSettings {
    return this.getItem<UserSettings>(this.settingsName)
  }

  public clearUserSettings(): void {
    localStorage.removeItem(this.settingsName)
  }

  public cleanAll(): void {
    localStorage.clear()
    location.reload()
  }
}
